export default function Social() {
    return (
        <div className="home__social" id="home">
            <a href="https://www.linkedin.com/in/setiawan-kevin/" className="home__social-icon" target="_black">
                <i className="uil uil-linkedin-alt"></i>
            </a>
            
            <a href="https://github.com/kevinwebtest/" className="home__social-icon" target="_black">
                <i className="uil uil-github-alt"></i>
            </a>
            
        </div>
    );
}
